<template>
  <div :class="['areceber-modern', { 'areceber-dark': isDark }]">
    <!-- Header Fixo Mobile -->
    <div class="modern-header mb-4">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <b-button variant="link" @click="$router.go(-1)" class="back-button mr-2">
            <i class="fa fa-chevron-left"></i>
          </b-button>
          <h4 class="title mb-0">Débitos do Cliente</h4>
        </div>
        <b-button v-if="registro.CLIENTE_ID" variant="warning" pill size="sm" @click.stop.prevent="imprimir()" class="shadow-sm">
          <i class="fa fa-print"></i>
        </b-button>
      </div>
    </div>

    <!-- Seção de Busca -->
    <div class="search-section mb-4">
      <div class="search-card shadow-sm">
        <cliente-pesquisa 
          @retornaId="registro.CLIENTE_ID = $event"
          :idInicial="registro.CLIENTE_ID"
          label="Selecione o Cliente"
          place="Pesquisar por nome ou código..."
          labelBotao=""
          ref="clientepesquisa"
          idModal="modalCliente">
        </cliente-pesquisa>
      </div>
    </div>

    <!-- Cards de Totais (Visíveis apenas se cliente selecionado) -->
    <div v-if="registro.CLIENTE_ID" class="actions-grid mb-4 animated fadeIn">
      <div class="action-item bg-primary-soft">
        <div class="action-icon">
          <i class="fa fa-calendar-check-o text-primary"></i>
        </div>
        <div class="action-data">
          <span class="value">{{numberToReal(totalEmDias)}}</span>
          <span class="label">Total em Dias</span>
        </div>
      </div>
      <div class="action-item bg-danger-soft">
        <div class="action-icon">
          <i class="fa fa-calendar-times-o text-danger"></i>
        </div>
        <div class="action-data">
          <span class="value">{{numberToReal(totalAtrasado)}}</span>
          <span class="label">Total Atrasado</span>
        </div>
      </div>
    </div>

    <!-- Lista de Títulos -->
    <div v-if="registro.CLIENTE_ID" class="titles-section animated fadeInUp">
      <div class="section-header mb-3">
        <h5 class="mb-0">Títulos em Aberto <b-badge pill variant="light" class="ml-2">{{tableItems.length}}</b-badge></h5>
      </div>

      <div v-if="tableItems.length" class="order-list">
        <div 
          v-for="(item, index) in tableItems" 
          :key="index" 
          class="order-card-luxury shadow-sm mb-3"
        >
          <!-- Header do Card -->
          <div :class="['card-luxury-header', 'status-' + variantColor(item.valor)]">
            <span class="status-name">
              <i :class="item.valor.percentualSemMascara >= 100 ? 'fa fa-check-circle' : 'fa fa-clock-o'"></i>
              {{ item.valor.dataVencimentoSemMascara < new Date() ? 'ATRASADO' : 'EM DIA' }}
            </span>
            <div class="header-metrics">
              <span class="h-date">{{item.valor.dataVencimento}}</span>
            </div>
          </div>

          <div class="card-luxury-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div class="lux-section-identity">
                <div class="order-id">DOCUMENTO: <strong>{{item.cliente.documento}}</strong></div>
                <div class="items-preview text-dark font-weight-bold">Parcela: {{item.cliente.parcela}}</div>
              </div>
              <div class="text-right">
                <div class="f-label small text-muted text-uppercase font-weight-bold" style="font-size: 0.6rem;">Valor Aberto</div>
                <div :class="['h5 mb-0 font-weight-bold', item.valor.classe]">{{item.valor.valorAberto}}</div>
              </div>
            </div>

            <div class="luxury-content border-top pt-2 mt-2">
              <div class="w-100">
                <div class="d-flex justify-content-between mb-1 small">
                  <span class="text-muted">Original: {{item.valor.valorDocumento}}</span>
                  <span class="font-weight-bold">{{item.valor.percentual}}%</span>
                </div>
                <b-progress 
                  height="6px" 
                  class="progress-modern" 
                  v-model="item.valor.percentualSemMascara" 
                  :variant="variantProgress(item.valor)"
                ></b-progress>
              </div>
            </div>

            <div v-if="item.dias != '0'" class="last-payment-info mt-2 pt-2 border-top">
              <small class="text-muted">
                <i class="fa fa-history mr-1"></i>
                Último pagamento: <strong>{{item.dias}} Dias Atrás</strong>
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Estado Vazio -->
      <div v-else class="empty-state text-center p-5 text-muted bg-white rounded shadow-sm">
        <i class="fa fa-check-circle-o fa-3x mb-3 text-success"></i>
        <p>Nenhum título em aberto encontrado para este cliente.</p>
      </div>
    </div>

    <!-- Estado Inicial -->
    <div v-else class="initial-state text-center p-5 text-muted">
      <div class="illustration mb-4">
        <div class="icon-circle bg-light d-inline-flex align-items-center justify-content-center" style="width: 80px; height: 80px; border-radius: 50%;">
          <i class="fa fa-user-circle-o fa-3x text-secondary"></i>
        </div>
      </div>
      <h5>Selecione um cliente</h5>
      <p class="small">Use a busca acima para consultar os débitos em aberto.</p>
    </div>
  </div>
</template>

<script>
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import moment from 'moment'

export default {
  name: 'AreceberPorCliente',
  components: {
    ClientePesquisa
  },
  data: function () {
    return {
      totalTitulos: 0,
      totalEmDias: 0,
      totalAtrasado: 0,
      quantTitulos: 0,
      registro: {
        CLIENTE_ID: null
      },
      parametros: {
        nomeCliente: ''
      },
      tableItems: [],
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] }
  },
  methods: {
    variantProgress (valor) {
      if (valor.dataVencimentoSemMascara < new Date()) {
        return 'danger'
      } else {
        return 'primary'
      }
    },
    variantColor (valor) {
      if (valor.dataVencimentoSemMascara < new Date()) {
        return 'danger'
      } else {
        return 'success'
      }
    },
    variantVencimento (value) {
      if ( moment(value).format('YYYY-MM-DD')  < moment().format('YYYY-MM-DD')  ) {
        return 'text-danger'
      } else {
        return 'text-primary'
      }
    },
    numberToReal (numero) {
      if (numero === undefined || numero === null) return 'R$ 0,00'
      return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    limparTabela () {
      this.tableItems = []
      this.totalAtrasado = 0
      this.totalEmDias = 0
    },
    listarTitulos () {
      if (this.registro.CLIENTE_ID === null || this.registro.CLIENTE_ID === undefined) {
        this.limparTabela()
        return
      }
      this.$store.commit('controle/setAguardando', true)
      let uri = this.$http.defaults.baseURL.concat(`api/protected/areceber/listartitulosporcliente?clienteid=${this.registro.CLIENTE_ID}`)
      let promise = this.$http.get(uri)
      this.tableItems = []
      promise.then((data) => {
        if (data && data.data) {
          let i
          this.totalAtrasado = this.totalEmDias = 0
          for (i = 0; i < data.data.length; i++) {
            const item = data.data[i]
            this.tableItems.push({
              cliente: { 
                nome: item.NOME_CLIENTE, 
                documento: item.DOCUMENTO, 
                parcela: item.PARCELA, 
                itens: item.ITENS 
              },
              valor: {  
                percentual: item.PERCENTUAL.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 1}), 
                percentualSemMascara: item.PERCENTUAL,
                valorDocumento: this.numberToReal(item.VL_DOC),
                valorAberto: this.numberToReal(item.VALOR_ABERTO), 
                valorAbertoSemMascara: item.VALOR_ABERTO, 
                dataVencimento: moment(item.DT_VENC).format('DD/MM/YYYY'),
                dataVencimentoSemMascara: new Date(item.DT_VENC),
                classe: this.variantVencimento(item.DT_VENC) 
              },
              dias: item.ULT_BAIXA_DIAS == null ? '0' : item.ULT_BAIXA_DIAS
            })
            if ( moment(item.DT_VENC).format('YYYY-MM-DD')  < moment().format('YYYY-MM-DD')  ) {
              this.totalAtrasado += item.VALOR_ABERTO
            } else {
              this.totalEmDias += item.VALOR_ABERTO
            }
          }
        }
      }).finally(() => {
        this.$store.commit('controle/setAguardando', false)
      })
    },
    imprimir () {
      if (this.registro.CLIENTE_ID == null) {
        this.$root.$bvToast.toast(`Selecione um cliente!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      let uri = '/api/protected/relatorios/relareceber?clienteid=' + this.registro.CLIENTE_ID +
        '&lbempresa=' + window.localStorage.getItem('nomeempresa') +
        '&grupoid=' + '' +
        '&dt1=' + '01-01-2000' +
        '&dt2=' + '01-01-2030' +
        '&lbcliente=' + (this.$refs.clientepesquisa.$refs.auto.selectedDisplay || '') +
        '&lbvendedor=' + '' +
        '&lbgrupo=' + '' +
        '&lbusuario=' + window.localStorage.getItem('nomeusuario') +
        '&tiporel=' + 'S' +
        '&tipoperiodo=' + 'V'
      
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.download = 'relatorioAreceber.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => { janela.document.title = 'Relatório de Contas a Receber' }, 2000)
          }
          this.$root.$bvToast.toast(`Relatório gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 4000,
            variant: 'success',
            appendToast: true
          })
        })
        .catch(erro => {
          this.$root.$bvToast.toast(`Ocorreu uma falha ao gerar o relatório!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'danger',
            appendToast: true
          })
        })
        .finally(() => {
          this.$store.commit('controle/setAguardando', false)
        })
    }
  },
  created () {
    this.limparTabela()
  },
  watch: {
    'registro.CLIENTE_ID': function() {
      this.listarTitulos()
    } 
  }
}
</script>

<style scoped lang="scss">
.areceber-modern {
  padding: 15px;
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.modern-header {
  .back-button {
    color: #4a5568;
    padding: 0;
    font-size: 1.2rem;
    &:focus { box-shadow: none; }
  }
  .title {
    font-weight: 800;
    color: #1a202c;
    letter-spacing: -0.5px;
    font-size: 1.25rem;
  }
}

.search-card {
  background: white;
  padding: 15px;
  border-radius: 16px;
  border: 1px solid #edf2f7;
}

/* Actions Grid (Totais) */
.actions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.action-item {
  padding: 15px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.03);
  border: 1px solid rgba(0,0,0,0.02);

  .action-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.15rem;
    margin-bottom: 8px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  }

  .action-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    .value {
      font-weight: 800;
      font-size: 0.95rem;
      color: #1a202c;
      letter-spacing: -0.5px;
      text-align: center;
    }
    .label {
      font-size: 0.6rem;
      color: #718096;
      text-transform: uppercase;
      font-weight: 700;
      letter-spacing: 0.5px;
      text-align: center;
    }
  }
}

.bg-primary-soft { background-color: #ebf8ff !important; border-color: #bee3f8 !important; }
.bg-danger-soft { background-color: #fff5f5 !important; border-color: #fed7d7 !important; }

/* Luxury Card Design */
.order-card-luxury {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #edf2f7;
  
  &:active { background-color: #f8fafc; }
}

.card-luxury-header {
  padding: 6px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .status-name {
    font-weight: 700;
    font-size: 0.65rem;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    i { margin-right: 4px; }
  }
  
  .header-metrics {
    .h-date { font-size: 0.75rem; font-weight: 600; }
  }
}

.status-success { background-color: #f0fff4; color: #38a169; border-bottom: 1px solid #c6f6d5; }
.status-danger { background-color: #fff5f5; color: #e53e3e; border-bottom: 1px solid #fed7d7; }

.card-luxury-body {
  padding: 15px;
}

.lux-section-identity {
  .order-id {
    font-size: 0.65rem;
    color: #a0aec0;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 2px;
    strong { color: #4a5568; }
  }
}

.progress-modern {
  border-radius: 12px;
  background-color: #edf2f7;
}

.last-payment-info {
  i { color: #cbd5e0; }
}

/* Animations */
.animated {
  animation-duration: 0.5s;
  animation-fill-mode: both;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeIn { animation-name: fadeIn; }
.fadeInUp { animation-name: fadeInUp; }

/* Scrollbar */
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 10px;
}

.initial-state {
  margin-top: 50px;
  h5 { font-weight: 700; color: #4a5568; }
  p { color: #a0aec0; }
}

/* Dark Mode Support */
.areceber-dark {
  background-color: #1e1e2d !important;
  color: #e2e8f0 !important;

  .modern-header .title { color: #f7fafc !important; }
  .modern-header .back-button { color: #cbd5e0 !important; }

  .search-card {
    background: #2d3748 !important;
    border-color: #4a5568 !important;
  }

  .action-item {
    background-color: #2d3748 !important;
    border-color: #4a5568 !important;
    .action-icon { background: #1a202c !important; }
    .action-data .value { color: #f7fafc !important; }
  }
  
  .bg-primary-soft { background-color: #2a4365 !important; border-color: #2c5282 !important; }
  .bg-danger-soft { background-color: #742a2a !important; border-color: #9b2c2c !important; }

  .order-card-luxury {
    background: #2d3748 !important;
    border-color: #4a5568 !important;
    &:active { background-color: #1a202c !important; }
  }

  .card-luxury-header {
    border-bottom-color: #4a5568 !important;
    color: #e2e8f0 !important;
  }
  
  .status-success { background-color: #22543d !important; border-color: #276749 !important; color: #9ae6b4 !important; }
  .status-danger { background-color: #742a2a !important; border-color: #9b2c2c !important; color: #feb2b2 !important; }

  .lux-section-identity .order-id { color: #cbd5e0 !important; strong { color: #f7fafc !important; } }
  .items-preview { color: #e2e8f0 !important; }

  .luxury-content { border-top-color: #4a5568 !important; }
  .last-payment-info { border-top-color: #4a5568 !important; }

  .empty-state { background-color: #2d3748 !important; border-color: #4a5568 !important; color: #a0aec0 !important; }
  .initial-state {
    h5 { color: #f7fafc !important; }
    p { color: #cbd5e0 !important; }
    .icon-circle { background-color: #2d3748 !important; }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/consultas/AreceberPorCliente.vue